import { isBrowser } from "@montana/helpers/browser.helper"

export interface IDeviceType {
    device: 'ipad' | 'iphone' | 'android' | 'desktop';
}

export function useDetectDevice(): IDeviceType {
    const type: IDeviceType = {device:'desktop'}
    if (isBrowser) {
        const deviceUserAgent = navigator.userAgent.toLowerCase();
        if (deviceUserAgent.includes('iphone')) {
            type.device = 'iphone';
        }
        if (deviceUserAgent.includes('ipad')) {
            type.device = 'ipad';
        }
        if (deviceUserAgent.includes('android')) {
            type.device = 'android';
        }
    }
    return type;
}


export const getMobileOS = () => {
    if (!isBrowser) return "Other";

    const ua = navigator?.userAgent

    if (!ua) return "Other";

    if (/android/i.test(ua)) {
      return "Android"
    }

    else if ((/iPad|iPhone|iPod/.test(ua)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
      return "iOS"
    }

    return "Other"
}

export const isAndroid = getMobileOS() === 'Android';
export const isIOS = getMobileOS() === 'iOS';
